// Turkish message translations
export const messages = {
  // Common UI elements
  "Send": "Gönder",
  "Clear chat": "Sohbeti temizle",
  "Support": "Destek",
  "Settings": "Ayarlar",
  "Language": "Dil",
  "Theme": "Tema",
  "Font Size": "Yazı Boyutu",
  "Select language": "Dil seçin",
  
  // Chat interface
  "Type your message...": "Mesajınızı yazın...",
  "Thinking...": "Düşünüyor...",
  "Labor Law Expert": "İş Hukuku Uzmanı",
  "by MJ": "MJ tarafından",
  "Leen": "Leen",
  
  // Frameworks
  "Automatic detection": "Otomatik algılama",
  "Labor Law": "İş Kanunu",
  "Saudization": "Suudi Arabistanlaştırma",
  "Contracts": "Sözleşmeler",
  "Termination": "İş Akdi Feshi",
  "Wages & Benefits": "Ücretler ve Yan Haklar",
  "Leave Policies": "İzin Politikaları",
  "Workplace Safety": "İş Yeri Güvenliği",
  
  // Models
  "Claude by Anthropic": "Anthropic'in Claude'u",
  "DeepSeek by Groq": "Groq'un DeepSeek'i",
  "MJ Lab Mode": "MJ Lab Modu",
  
  // Messages
  "Language changed to {{locale}}": "Dil {{locale}} olarak değiştirildi",
  "Hello, I am {{name}}, an AI assistant made by MJ.": "Merhaba, ben {{name}}, MJ tarafından yapılmış bir yapay zeka asistanıyım.",
  "I am expert in labor laws and regulations for Saudi Arabia.": "Suudi Arabistan'ın iş kanunları ve düzenlemeleri konusunda uzmanım.",
  "Ask me a question, and I will gladly answer you.": "Bana bir soru sorun, memnuniyetle cevap vereceğim.",
  "Do not share confidential data.": "Gizli verileri paylaşmayın.",
  "I am powered using": "Çalışma kaynağım",
  
  // Disclaimer
  "Disclaimer: {{name}} is an experimental AI assistant designed to respond using data from Saudi labor laws and regulations, avoiding assumptions or inaccuracies. I am not responsible for its behavior or the correctness of its responses.": "**Feragatname:** {{name}}, varsayımlardan veya yanlışlıklardan kaçınarak Suudi Arabistan iş kanunları ve düzenlemelerinden veri kullanarak yanıt vermek üzere tasarlanmış deneysel bir yapay zeka asistanıdır. Davranışlarından veya yanıtlarının doğruluğundan sorumlu değilim.",
  
  // Frameworks
  "Automatic detection": "Otomatik algılama",
  "Labor Law": "İş Kanunu",
  "Saudization": "Suudileştirme",
  "Contracts": "Sözleşmeler",
  "Termination": "İş Akdi Feshi",
  "Wages & Benefits": "Ücretler ve Haklar",
  "Leave Policies": "İzin Politikaları",
  "Workplace Safety": "İş Güvenliği",
  
  // Error messages
  "An error occurred": "Bir hata oluştu",
  "Failed to change language": "Dil değiştirilemedi",
  "Please try again": "Lütfen tekrar deneyin",
  "Connection lost": "Bağlantı kesildi",
  "Reconnecting...": "Yeniden bağlanıyor...",
  "Nothing to clear": "Temizlenecek bir şey yok",
  "All messages cleared": "Tüm mesajlar temizlendi",
  "All data cleared": "Tüm veriler temizlendi",
  "Storage limit reached": "Depolama sınırına ulaşıldı",
  "Some older messages were removed to save space.": "Alan kazanmak için bazı eski mesajlar kaldırıldı.",
  "Error": "Hata",
  
  // Tooltips
  "Increase font size": "Yazı boyutunu artır",
  "Decrease font size": "Yazı boyutunu azalt",
  "Reset font size": "Yazı boyutunu sıfırla",
  "Change theme": "Temayı değiştir",
  "Support the project": "Projeyi destekle",
  
  // Character count
  "{{remainingChars}} character left": "{{remainingChars}} karakter kaldı",
  "{{remainingChars}} characters left": "{{remainingChars}} karakter kaldı",
  
  // Message actions
  "Message copied to clipboard": "Mesaj panoya kopyalandı",
  "Read": "Oku",
  "Summarize": "Özetle",
  
  // Ice Breakers Dialog
  "Message Suggestions": "Mesaj Önerileri",
  "Select a question to quickly start a conversation about Saudi labor laws.": "Suudi Arabistan iş kanunları hakkında hızlı bir şekilde konuşma başlatmak için bir soru seçin.",
  "What are the key employee rights under Saudi labor law? Can you provide a simple overview?": "Suudi Arabistan iş kanunu kapsamında temel çalışan hakları nelerdir? Basit bir genel bakış sağlayabilir misiniz?",
  "What are the employer's obligations regarding work hours, overtime, and leave in Saudi Arabia?": "Suudi Arabistan'da işverenin çalışma saatleri, fazla mesai ve izin konusundaki yükümlülükleri nelerdir?",
  "How does Saudi labor law handle termination of employment and end-of-service benefits?": "Suudi Arabistan iş kanunu, iş akdinin feshi ve kıdem tazminatını nasıl ele alır?",
  
  // Audio Player Dialog
  "AI Summary": "Yapay Zeka Özeti",
  "Listen to the summarized response using our AI Service.": "Yapay Zeka Servisimizi kullanarak özetlenmiş yanıtı dinleyin.",
  "Generating summary...": "Özet oluşturuluyor...",
  "Preparing audio...": "Ses hazırlanıyor...",
  
  // Audio Player Error Messages
  "Failed to process text. Please try again.": "Metin işlenemedi. Lütfen tekrar deneyin.",
  "Failed to auto-play audio. Click play to try again.": "Ses otomatik oynatılamadı. Tekrar denemek için oynat'a tıklayın.",
  "Failed to load audio. Please try again.": "Ses yüklenemedi. Lütfen tekrar deneyin.",
  "Audio playback was aborted.": "Ses oynatma iptal edildi.",
  "Network error occurred while loading audio.": "Ses yüklenirken ağ hatası oluştu.",
  "Audio decoding failed.": "Ses kodu çözülemedi.",
  "Audio format not supported.": "Ses formatı desteklenmiyor.",
  "Failed to setup audio playback": "Ses oynatma ayarlanamadı",
  "Failed to generate speech": "Konuşma oluşturulamadı",
  "Failed to generate audio. Please try again.": "Ses oluşturulamadı. Lütfen tekrar deneyin.",
  "Failed to play audio. Please try again.": "Ses oynatılamadı. Lütfen tekrar deneyin.",
  
  // Update Notifications
  "update.updateAvailable": "Güncelleme Mevcut",
  "update.newVersionAvailable": "Yeni Sürüm {{version}} Mevcut",
  "update.refreshToApply": "En son özellikleri ve iyileştirmeleri uygulamak için yenileyin",
  "update.later": "Daha Sonra",
  "update.updateNow": "Şimdi Güncelle",
  
  // CSAT Feedback
  "We Value Your Feedback": "Geri Bildiriminizi Önemsiyoruz",
  "Give Feedback": "Geribildirim Ver",
  "How would you rate your experience?": "Deneyiminizi nasıl değerlendirirsiniz?",
  "Very Dissatisfied": "Çok Memnun Değilim",
  "Dissatisfied": "Memnun Değilim",
  "Neutral": "Nötr",
  "Satisfied": "Memnunum",
  "Very Satisfied": "Çok Memnunum",
  "Select a rating": "Bir değerlendirme seçin",
  "Comments or Bug Report": "Yorumlar veya Hata Bildirimi",
  "Please share your thoughts or report any issues...": "Lütfen düşüncelerinizi paylaşın veya sorunları bildirin...",
  "Contact Number": "İletişim Numarası",
  "Feedback Type": "Geribildirim Türü",
  "Select a feedback type": "Bir geribildirim türü seçin",
  "Loading...": "Yükleniyor...",
  "No feedback types available": "Geribildirim türü bulunmuyor", 
  "(Optional)": "(İsteğe bağlı)",
  "Feedback Submitted": "Geribildirim Gönderildi",
  "Thank you for your feedback!": "Geribildiriminiz için teşekkürler!",
  "Rating Required": "Değerlendirme Gerekli",
  "Please select a rating before submitting.": "Göndermeden önce lütfen bir değerlendirme seçin.",
  "Submit Feedback": "Geribildirim Gönder",
  "Submitting...": "Gönderiliyor...",
  "General": "Genel",
  "Bug": "Hata",
  "Idea": "Fikir",
  
  // Feedback Dashboard
  "Feedback Dashboard": "Geribildirim Panosu",
  "Total Feedbacks": "Toplam Geribildirim",
  "All-time submissions": "Tüm zamanların gönderileri",
  "Average Rating": "Ortalama Değerlendirme",
  "Out of 5 stars": "5 yıldız üzerinden",
  "Feedback with Comments": "Yorumlu Geribildirimler",
  "Detailed feedback": "Detaylı geribildirim",
  "Rating Distribution": "Değerlendirme Dağılımı",
  "Breakdown of user satisfaction": "Kullanıcı memnuniyeti dağılımı",
  "Rating Percentage": "Değerlendirme Yüzdesi",
  "Proportion of each rating": "Her değerlendirmenin oranı",
  "Responses": "Yanıtlar",
  "All Feedback": "Tüm Geribildirimler",
  "Detailed view of user submissions": "Kullanıcı gönderilerinin detaylı görünümü",
  "ID": "Kimlik",
  "Rating": "Değerlendirme",
  "Comment": "Yorum",
  "Contact": "İletişim",
  "Date": "Tarih",
  "Page": "Sayfa",
  "No feedback data available": "Geribildirim verisi bulunmuyor",
  "No comment": "Yorum yok",
  "Not provided": "Belirtilmemiş",
  "Not available": "Mevcut değil",
  
  // Authentication
  "Login": "Giriş Yap",
  "Register": "Kaydol",
  "Username": "Kullanıcı adı",
  "Password": "Şifre",
  "Confirm Password": "Şifreyi Onayla",
  "Email": "E-posta",
  "Full Name": "Tam Ad",
  "Don't have an account?": "Hesabınız yok mu?",
  "Already have an account?": "Zaten bir hesabınız var mı?",
  "Login to continue": "Devam etmek için giriş yapın",
  "Create an account": "Hesap oluştur",
  "Passwords must match": "Şifreler eşleşmeli",
  "Invalid email": "Geçersiz e-posta",
  "Required": "Gerekli",
  "Unauthorized": "Yetkisiz",
  "You don't have permission to access this page.": "Bu sayfaya erişim izniniz yok."
};